import { UiMode } from 'new/constants/uiMode';

/**
 * ui.mode semantics:
 *
 *   "code"  → resource was last saved from the JSON editor; auto-open JSON editor on next edit
 *   absent  → normal VIEW mode (the default for all resources)
 *
 * Only ui.mode: "code" is persisted to the API. The value "view" may appear
 * transiently in internal UI state (e.g. during CODE→VIEW switch) but is
 * stripped at the API save boundary in AddDataSourceForm and DestinationSetup.
 *
 * Nothing in the UI checks for === "view"; everything uses isUiModeCode().
 * A future cleanup could replace all internal "view" assignments with
 * withUiModeRemoved() and remove UiMode.VIEW entirely, but the current
 * approach is correct and well-tested.
 */

export const isUiModeCode = (resourceConfig?: Record<string, any>) => {
  return resourceConfig?.['ui.mode'] === UiMode.CODE;
};

export const withUiModeDefault = (config: Record<string, any> = {}) => {
  // No-op: VIEW mode is the absence of ui.mode, not ui.mode: "view".
  return config;
};

export const withUiModeCode = (config: Record<string, any> = {}) => {
  return { ...config, ['ui.mode']: UiMode.CODE };
};

/** Remove ui.mode from config entirely. */
export const withUiModeRemoved = (config: Record<string, any> = {}) => {
  const { ['ui.mode']: _, ...rest } = config;
  return rest;
};
